import React from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const Dot = ({ color, ...props }: IconProps) => {
    return (
        <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M2.5 4.63068C2.09896 4.63068 1.73272 4.53291 1.40128 4.33736C1.06984 4.13849 0.804688 3.87334 0.605824 3.5419C0.410275 3.21046 0.3125 2.84422 0.3125 2.44318C0.3125 2.03883 0.410275 1.67259 0.605824 1.34446C0.804688 1.01302 1.06984 0.749526 1.40128 0.553977C1.73272 0.355113 2.09896 0.255682 2.5 0.255682C2.90436 0.255682 3.2706 0.355113 3.59872 0.553977C3.93016 0.749526 4.19366 1.01302 4.3892 1.34446C4.58807 1.67259 4.6875 2.03883 4.6875 2.44318C4.6875 2.84422 4.58807 3.21046 4.3892 3.5419C4.19366 3.87334 3.93016 4.13849 3.59872 4.33736C3.2706 4.53291 2.90436 4.63068 2.5 4.63068Z"
                fill={color || "#000"}
            />
        </svg>
    )
}

export default Dot
